import React, {Component} from 'react';

type Props = { backLinkCb: () => void }

class CardWrapper extends Component<Props, {}> {

    back(e) {
        e.preventDefault();

        this.props.backLinkCb();
    }

    render() {
        return (
            <>
            <div className="card">
                <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                        <a href="" onClick={ e => this.back(e) }>Tagasi</a>
                    </li>
                    <li className="list-group-item">
                        { this.props.children }
                    </li>
                </ul>
            </div>
            </>);
    }
}

export default CardWrapper